import { createFileRoute, notFound, Outlet, redirect } from "@tanstack/react-router";

import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar/sidebar";
import { versionQueryOptions } from "@/hooks/query/thread";

import { LearnSidebar } from "../-components/learn-sidebar";

export const Route = createFileRoute("/learn/$versionId")({
	component: RouteComponent,
	beforeLoad: async ({ params, context }) => {
		const query = versionQueryOptions({ versionId: params.versionId });
		const access = await context.queryClient.ensureQueryData(query);

		if (!access) {
			throw notFound();
		}

		if (!context.user) {
			throw redirect({ to: "/sign-in", search: { from: `/learn/${params.versionId}` } });
		}

		return {
			versionTitle: access.share?.title,
			visibility: access.share?.visibility,
			status: access.status,
		};
	},
});

function RouteComponent() {
	const { versionId } = Route.useParams();

	return (
		<SidebarProvider>
			<LearnSidebar currentVersionId={versionId} />
			<SidebarInset>
				<Outlet />
			</SidebarInset>
		</SidebarProvider>
	);
}
